<template>
  <div class="flex h-full justify-center">
    <!-- <toggle-button
      :value="params.data.actionData.toggle"
      :color="{checked: '#35C76F', unchecked: '#EA5455', disabled: '#CCCCCC'}"
      class="mt-3 mr-1"
      @change="handleChange"
    /> -->
    <!-- <vs-switch color="success" v-model="toggle" @change="handleChange" class="mr-2 mt-2" style="vertical-align: top !important;" /> -->
    <!-- <vs-button
      color="primary"
      type="border"
      icon-pack="feather"
      icon="icon-eye"
      class="mr-2"
      @click="hanldeViewSidebar"
    ></vs-button> -->
    <vs-dropdown style="cursor: pointer;" vs-custom-content vs-trigger-click>
      <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

      <vs-dropdown-menu>
        <!-- <vs-dropdown-item style="width: 100px;">&#43; Todo</vs-dropdown-item>
        <vs-dropdown-item>&#43; Note</vs-dropdown-item>
        <vs-dropdown-item>&#43; Meeting</vs-dropdown-item>
        <vs-dropdown-item>&#43; Email</vs-dropdown-item> -->
        <vs-dropdown-item @click="handleEdit">Edit</vs-dropdown-item>
        <vs-dropdown-item @click="showPopUp(!showPopUpBool)">Delete</vs-dropdown-item>
        <vs-dropdown-item @click="hanldeViewSidebar">Preview</vs-dropdown-item>
        <vs-dropdown-item @click="sendEmail">Send Invitation</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup
        classContent="popup-example"
        title="Please Confirm"
        :active.sync="showPopUpBool"
      >
        <h4>Are you sure to delete the student?</h4>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click="haldleDelete()">Confirm</vs-button>
          <vs-button type="border" color="danger" @click="showPopUpBool = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
  </div>
</template>
<script>
import { Clienttoogle, deleteClient, sendInvitation } from '@/api/client'
// import { sendInvitation } from '@/api/client'
// import { Delete_Leads } from '@/api/leads'
import { mapActions } from 'vuex'
// import { ToggleButton } from 'vue-js-toggle-button'
export default {
  name: 'CellRendererActions',
  // components: {
  //   ToggleButton
  // },
  props: {
    // localValue: actionData,
  },
  mounted () {
    this.action = this.params.data.actionData
    this.toggle = this.params.data.actionData.toggle
  },
  data () {
    return {
      action: {},
      toggle: null,
      showPopUpBool: false
    }
  },
  methods: {
    ...mapActions([
      'SET_CLIENT_DELETE_ID',
      'SET_VIEW_CLIENT_SIDEBAR',
      'SET_VIEW_CLIENT_SIDEBAR_DATA',
      'SET_CLIENT_TOGGLE_DATA'
    ]),
    // async handleChange () {
    //   
    //   try {
    //     const client_users_id = this.params.data.basic_details.client_users_id
    //     

    //     const togglePayload = {
    //       active_user: this.params.data.actionData.toggle ? 0 : 1,
    //       client_user_id: this.params.data.basic_details.client_users_id
    //     }
    //     
    //     const { data } = await Clienttoogle(togglePayload)
    //     
    //     const storePayload = {
    //       row_details: this.params.data,
    //       toggle: !this.params.data.actionData.toggle
    //     }
    //     this.SET_CLIENT_TOGGLE_DATA(storePayload)
    //     this.$vs.notify({
    //       title: 'Success',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'success'
    //     })
    //   } catch (e) {
    //     
    //     this.$vs.notify({
    //       title: 'Warning',
    //       text: e,
    //       ...this.warnProp()
    //     })
    //   }
    // },
    async haldleDelete () {
      const deleting_id = this.params.data.basic_details.client_users_id
      const payload = {
        client_user_id: [deleting_id]
      }
      
      if (!this.params.data.actionData.toggle) {
        if (this.params.data.basic_details.user_type === 'Parent' && this.params.data.children.length > 0) {
          const initial = this.params.data.children[0].child.active_user === '1'
          const ischildDeactive = this.checkAllChildDeactive(this.params.data.children, initial)
          if (!ischildDeactive) {
            try {
              const data = await deleteClient(payload, this.$store.getters.customerId)
              this.SET_CLIENT_DELETE_ID(deleting_id)
              
              this.$vs.notify({
                title: 'Client Deleted',
                text: 'Client Deleted Successfully',
                ...this.successProp()
              })
            } catch (error) {
              
            }
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: 'Deactive all minor first',
              ...this.warnProp()
            })
          }
        } else {
          try {
            const data = await deleteClient(payload, this.$store.getters.customerId)
            this.SET_CLIENT_DELETE_ID(deleting_id)
            
            this.$vs.notify({
              title: 'Client Deleted',
              text: 'Client Deleted Successfully',
              ...this.successProp()
            })
          } catch (error) {
            
          }
        }


      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Can’t remove an active student. Please deactivate the student first',
          ...this.warnProp()
        })
      }
      
    },
    handleEdit () {
      const client_users_id = this.params.data.basic_details.client_users_id

      if (this.params.data.basic_details.active_user === '0') {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t edit non actionable row",
          ...this.warnProp(),
        });
        return false
      }

      this.$router.push(
        `/student-profile/${client_users_id}?mode=edit`
      )
    },
    hanldeViewSidebar () {
      const viewbutton = true
      this.SET_VIEW_CLIENT_SIDEBAR(viewbutton)
      this.SET_VIEW_CLIENT_SIDEBAR_DATA(this.params.data)
    },
    async sendEmail () {
      try {
        const data = await sendInvitation(this.$store.getters.customerId,this.params.data.basic_details.client_users_id)
        this.$vs.notify({
          title: 'Success',
          text: data.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        this.$vs.notify({
          title: 'Success',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      }    
    },
    showPopUp () {
      if (this.params.data.basic_details.active_user !== '1') {
        this.showPopUpBool  = true
      } else {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t delete non actionable row",
          ...this.warnProp(),
        });
      }
    },
    // hanldeViewSidebar () {
    //   const viewbutton = true
    //   this.SET_VIEW_CLIENT_SIDEBAR(viewbutton)
    //   this.SET_VIEW_CLIENT_SIDEBAR_DATA(this.params.data)
    // },
    checkAllChildDeactive (childs, initial) {
      let check = initial
      for (const item of childs) {
        // let check = null
        const itr = item.child.active_user === '1'
        check = check && itr
      }
      return check
    }
  }
}
</script>
